<template>
    <v-app>
        <core-view-shared />
    </v-app>
</template>

<script>
import CoreViewShared from "@cmp/core/ViewShared.vue";

export default {
    name: "Shared",

    metaInfo: {
        title: "Home",
    },

    components: {
        CoreViewShared,
    },

    data: () => ({
        drawer: false,
        expandOnHover: false,
    }),

    computed: {
        showFadeInBackground() {
            if (!this.$route) {
                return true;
            }

            if (this.$route.meta?.noBackground) {
                return false;
            }

            if (this.$route.meta?.public) {
                return true;
            }

            return false;
        },

        showAppBarAndDrawer() {
            if (!this.$route) {
                return false;
            }

            if (this.$route.meta?.public) {
                return false;
            }

            return true;
        },
    },

    created() {
        if (this.$vuetify.breakpoint.mdAndUp) {
            this.drawer = true;
        }
        this.$vuetify.theme.dark = false;
    },
};
</script>
